import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["usersToNotifyForExportApproval", "exportApprovalRequestMessage"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { MAX_MESSAGE_LENGTH } from './ApprovalStep';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
function ApprovalStepSubmitButton(_ref) {
  let {
      usersToNotifyForExportApproval,
      exportApprovalRequestMessage
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const getMessage = () => {
    if (usersToNotifyForExportApproval.length === 0) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.approvalStep.approvalStepSubmitButtonDisabledNoApprovers"
      });
    }
    if (exportApprovalRequestMessage.length > MAX_MESSAGE_LENGTH) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.approvalStep.approvalStepSubmitButtonDisabledLargeMessage",
        options: {
          maxLength: MAX_MESSAGE_LENGTH
        }
      });
    }
    return null;
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !getMessage(),
    title: getMessage(),
    children: /*#__PURE__*/_jsx(LoadingButton, Object.assign({}, props, {
      disabled: Boolean(getMessage()),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.approvalStep.approvalStepSubmitButton"
      })
    }))
  });
}
export default ApprovalStepSubmitButton;